//
export default [
    /*{
        text    : '#',
        value   : 'id',
    },*/
    {
        text    : 'Empleado',
        value   : ({ hr_employee }) => [ hr_employee.names, hr_employee.last_name1, hr_employee.last_name2 ].join( ' ' ), 
        width   : '25%',
    },
    {
        align   : 'center',
        sortable: true,
        text    : 'Periodo (año)',
        value   : 'period_year',
    },
    {
        align   : 'center',
        sortable: true,
        text    : 'Asignado (dias)',
        value   : 'assigned_days',
    },
    {
        align   : 'center',
        sortable: true,
        text    : 'Consumido (dias)',
        value   : 'consumed_days',
    },
    {
        align   : 'center',
        text    : 'Pendiente (dias)',
        value   : 'pending_days',
    },
]